module.exports = __webpack_public_path__ + "img/yunting.cc14764a.webp";